// src/components/Footer.jsx
import React from "react";
import {
  FaTwitter,
  FaFacebook,
  FaLine,
  FaLink,
} from "react-icons/fa";
import "./home.css";

const Footer = () => {
  const currentUrl = window.location.href;

  const handleShare = (platform) => {
    const encodedUrl = encodeURIComponent(currentUrl);
    const text = encodeURIComponent("面白いスレッドを見つけました！");

    switch (platform) {
      case "twitter":
        window.open(`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`, "_blank");
        break;
      case "facebook":
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, "_blank");
        break;
      case "line":
        window.open(`https://social-plugins.line.me/lineit/share?url=${encodedUrl}`, "_blank");
        break;
      case "copy":
        navigator.clipboard.writeText(currentUrl);
        alert("リンクをコピーしました！");
        break;
      default:
        break;
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <p>© 2025 Mind Threat. All rights reserved.</p>

        <div className="footer-links">
          <a href="/terms">利用規約</a>
          <a href="/privacy">プライバシーポリシー</a>
          <a href="/contact">お問い合わせ</a>
        </div>

        {/* ✅ SNS共有ボタン */}
        <div className="social-share">
          <p>このページを共有：</p>
          <div className="share-buttons">
            <button
              className="share-btn twitter"
              onClick={() => handleShare("twitter")}
              aria-label="Twitterで共有"
            >
              <FaTwitter />
            </button>
            <button
              className="share-btn facebook"
              onClick={() => handleShare("facebook")}
              aria-label="Facebookで共有"
            >
              <FaFacebook />
            </button>
            <button
              className="share-btn line"
              onClick={() => handleShare("line")}
              aria-label="LINEで共有"
            >
              <FaLine />
            </button>
            <button
              className="share-btn copy"
              onClick={() => handleShare("copy")}
              aria-label="リンクをコピー"
            >
              <FaLink />
            </button>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
